/* =============================================================================
   vp-mobile.js — mobile UX-Verbesserungen, UX-Audit
   Geladen ueber snippets/custom-assets.liquid (im <head> jeder Seite).

   Enthalten:
   - Lange Kollektionsbeschreibungen werden mobil nach 7 Zeilen eingeklappt
     und ueber einen Button "Mehr erfahren" aufgeklappt.
   - Produktgalerie: die uebrigen Bilder werden im Hintergrund vorgeladen,
     damit der Bildwechsel nicht mehr weiss aufblitzt.
   ============================================================================= */
(function () {
  'use strict';

  if (window.__vpMobile) return;
  window.__vpMobile = true;

  var MQ = window.matchMedia('(max-width: 768px)');
  var CLAMP_LINES = 7;

  /* Beschriftungen aus custom-assets.liquid (window.vpI18n), seit 29.09.2026
     sprachabhaengig. Ohne das Objekt bleibt es beim deutschen Text. */
  var I18N = window.vpI18n || {};
  var TXT_MORE = I18N.more || 'Mehr erfahren';
  var TXT_LESS = I18N.less || 'Weniger anzeigen';

  /* ---------------------------------------------------------------------------
     Kollektionsbeschreibung einklappen (nur mobil)
     ------------------------------------------------------------------------- */
  function initCollectionDescription() {
    var desc = document.querySelector('.collection-hero__description');
    if (!desc) return;
    if (!MQ.matches) return;
    if (desc.getAttribute('data-vp-clamp') === 'ready') return;

    var lineHeight = parseFloat(window.getComputedStyle(desc).lineHeight);
    if (!lineHeight || isNaN(lineHeight)) lineHeight = 24;
    var maxHeight = Math.round(lineHeight * CLAMP_LINES);

    if (desc.scrollHeight <= maxHeight + 8) return;

    desc.setAttribute('data-vp-clamp', 'ready');
    desc.classList.add('vp-clamped');
    desc.style.maxHeight = maxHeight + 'px';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--brutalist outlined-button vp-more-toggle';
    button.setAttribute('aria-expanded', 'false');

    var label = document.createElement('span');
    label.textContent = TXT_MORE;
    button.appendChild(label);

    button.addEventListener('click', function () {
      var expanded = desc.classList.toggle('vp-expanded');
      desc.style.maxHeight = expanded ? 'none' : maxHeight + 'px';
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      label.textContent = expanded ? TXT_LESS : TXT_MORE;
    });

    desc.insertAdjacentElement('afterend', button);
  }

  /* ---------------------------------------------------------------------------
     Produktgalerie vorladen

     Ausgangslage: nur das erste Galeriebild traegt loading="eager", alle
     weiteren sind lazy und starten den Download erst beim Umschalten — daher
     das weisse Aufblitzen.

     Laeuft auf JEDEM Geraet und JEDER Verbindung (Wunsch vom 26.08.2026).
     Keine Ausnahme mehr fuer Datensparmodus oder 2G.

     Zeitpunkt: NICHT am load-Event der Seite haengen — das feuerte auf
     Produktseiten teils erst nach 13 Sekunden, und wer vorher wischt, sah
     weiter Weiss. Stattdessen wird gestartet, sobald das erste (grosse)
     Galeriebild fertig ist. Genau dann wird Bandbreite frei, und der First
     Paint ist nicht mehr betroffen. Notbremse nach 2,5 s, falls das erste
     Bild aus dem Cache kommt oder haengt.

     Reihenfolge: zuerst allein das unmittelbar naechste Bild — das ist das,
     welches beim ersten Wischen gebraucht wird. Danach der Rest mit zwei
     parallelen Anfragen, damit es auf dem Handy zuegig durchlaeuft, ohne die
     Leitung mit einem Dutzend gleichzeitiger Downloads zu verstopfen.
     ------------------------------------------------------------------------- */
  function warmImage(img, done) {
    var settled = false;
    function finish() {
      if (settled) return;
      settled = true;
      if (done) done();
    }

    var pre = new Image();
    pre.addEventListener('load', finish);
    pre.addEventListener('error', finish);

    /* sizes/srcset mituebernehmen, damit der Browser dieselbe Bildvariante
       waehlt wie spaeter das echte <img> — sonst waere der Cache nutzlos. */
    if (img.getAttribute('sizes')) pre.sizes = img.getAttribute('sizes');
    if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
    if (img.getAttribute('src')) pre.src = img.getAttribute('src');

    img.setAttribute('loading', 'eager');

    if (pre.complete) finish();
  }

  function preloadProductGallery() {
    var scope = document.querySelector('.product__media-wrapper');
    if (!scope) return;

    var pending = Array.prototype.filter.call(
      scope.querySelectorAll('img'),
      function (img) { return img.getAttribute('loading') === 'lazy'; }
    );
    if (!pending.length) return;

    var index = 1;
    var CONCURRENCY = 2;

    function pump() {
      if (index >= pending.length) return;
      var img = pending[index];
      index += 1;
      warmImage(img, function () {
        window.setTimeout(pump, 0);
      });
    }

    function startRest() {
      for (var i = 0; i < CONCURRENCY; i++) pump();
    }

    /* Phase 1: das unmittelbar naechste Bild zuerst und allein. */
    warmImage(pending[0], startRest);
  }

  function whenHeroReady(callback) {
    var scope = document.querySelector('.product__media-wrapper');
    if (!scope) return;

    var hero = scope.querySelector('img');
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      callback();
    }

    if (!hero || (hero.complete && hero.naturalWidth > 0)) {
      go();
      return;
    }

    hero.addEventListener('load', go);
    hero.addEventListener('error', go);
    window.setTimeout(go, 2500);
  }

  function run() {
    try {
      initCollectionDescription();
    } catch (e) {
      /* Eine fehlgeschlagene Verbesserung darf die Seite nicht blockieren. */
    }
  }

  function runGallery() {
    try {
      whenHeroReady(preloadProductGallery);
    } catch (e) {
      /* siehe oben */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run();
      runGallery();
    });
  } else {
    run();
    runGallery();
  }

  if (typeof MQ.addEventListener === 'function') {
    MQ.addEventListener('change', run);
  }

  document.addEventListener('shopify:section:load', function () {
    run();
    runGallery();
  });
})();
